import { render, staticRenderFns } from "./ModuleProductDetailDesc.vue?vue&type=template&id=0d2a15df&scoped=true&lang=html"
import script from "./ModuleProductDetailDesc.vue?vue&type=script&lang=js"
export * from "./ModuleProductDetailDesc.vue?vue&type=script&lang=js"
import style0 from "./ModuleProductDetailDesc.vue?vue&type=style&index=0&id=0d2a15df&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2a15df",
  null
  
)

export default component.exports